import Carousel from 'react-material-ui-carousel'
import {Grid, Hidden, Paper} from "@material-ui/core";

import fajitas from '../../common/images/food/fajitas.jpg';
import margherita from '../../common/images/drinks/margherita.jpg';
import castanedaTaco from '../../common/images/castaneda_taco2.jpg';
import outside2Image from '../../common/images/outside/outside2.jpg';
import bar1Image from '../../common/images/inside-main/bar1.jpg';
import seating1Image from '../../common/images/inside-main/seating1.jpg';
import '../styles.scss';

const Item = (props) => {
  if (props.item.video) {
    return (
      <Paper style={{
        border: '1px solid black',
        height: '500px',
      }}>
        <Grid container style={{ height: '100%' }}>
          <Grid item xs={6} sm={3} style={{ border: '1px solid #caab0e' }}>
            <div
              style={{
                width: '100%',
                height: '100%',
                backgroundImage: `url(${fajitas})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}/>
          </Grid>

          <Hidden xsDown>
            <Grid item sm={4} style={{ border: '1px solid #caab0e' }}>
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  backgroundImage: `url(${margherita})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}/>
            </Grid>
          </Hidden>

          <Grid item xs={6} sm={5} style={{ border: '1px solid #caab0e' }}>
            <div
              style={{
              width: '100%',
              height: '100%',
              backgroundImage: `url(${castanedaTaco})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
           }}/>
          </Grid>

        </Grid>
      </Paper>
    )
  }
  return (
    <Paper style={{
      border: '1px solid black',
      backgroundImage: `url(${props.item.img})`,
      backgroundSize: 'cover',
      backgroundPosition: props.item.position,
      height: '500px'
    }}>
      {
        (props.description || props.name) &&
        <div
          style={{
            position: 'absolute',
            right: 1,
            bottom: 1,
            margin: 20,
            padding: 10,
            border: '1px solid black',
            backgroundColor: 'rgba(140,140,140,0.7)',
          }}>
          <h2>{props.item.name}</h2>
          <p>{props.item.description}</p>
        </div>
      }
    </Paper>
  )
};


const Example = (props) => {
  const items = [
    {
      // name: "Located at:",
      description: "231 Chicago Ave. Goshen, IN 46526",
      img: outside2Image,
      position: 'center',
    },
    {
      // name: "Random Name #1",
      // description: "Probably the most random thing you have ever seen!",
      img: bar1Image,
      position: 'center',
    },
    {
      // name: "Random Name #2",
      // description: "Hello World!",
      img: seating1Image,
      position: 'center',
    },
    {
      video: true,
      text: 'This is a test'
    }
  ]

  return (
    <Carousel
      animation="slide"
      indicators={false}
    >
      {
        items.map( (item, i) => <Item key={i} item={item} /> )
      }
    </Carousel>
  )
}


const HomepageTitle = () => {
  return (
    <Grid container justify="center">
      <Grid item xs={12}>
        <div style={{ background: 'black' }}>
          <Example />
        </div>
      </Grid>
    </Grid>
  )
};

export default HomepageTitle;
